module.exports = __webpack_public_path__ + "img/sliderMobil1.c9c38ce6.jpg";